import React from 'react';

import { ReactComponent as ErrorIcon } from '../../../../../assets/icons/error-color-icon-ne.svg';
import { ReactComponent as InfoIcon } from '../../../../../assets/icons/info-color-icon-ne.svg';
import { ReactComponent as AlertIcon } from '../../../../../assets/icons/v3/alert-circle.svg';
import { ReactComponent as SuccessIcon } from '../../../../../assets/icons/v3/success.svg';
import { CARD_STATUS } from '../../../../constants/constants';
import { IStatusCardProps } from '../../../../interfaces/global';
import './StatusCard.scss';

const StatusCard = ({ message, type, className = '' }: IStatusCardProps) => {
  const loadImage = () => {
    if (type === CARD_STATUS.success) {
      return <SuccessIcon />;
    }
    if (type === CARD_STATUS.error) {
      return <ErrorIcon />;
    }
    if (type === CARD_STATUS.informative) {
      return <InfoIcon />;
    }
    return <AlertIcon />;
  };

  return (
    <div className={`w-full flex status-card-container-v3 ${type} p-4 ${className}`} data-experience="new">
      <div className=" h-6 w-6">{loadImage()}</div>
      <div className="status-card-text-v3 self-center pl-2 text-left"> {message} </div>
    </div>
  );
};

export default StatusCard;
